import axios from 'axios'

const instance = axios.create({
    baseURL: '/api'   
})

instance.interceptors.request.use((config) => {
    const token = window.localStorage.getItem('token')
    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }
    return config
})

instance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            window.localStorage.removeItem('token')
        }
        return Promise.reject(error)
    }
)

export default instance